import { useEffect, useState } from "react";
import { onValue, ref } from "firebase/database";
import { db } from "../config/firebase.js";

export function GoogleUsersCounter() {
  const [count, setCount] = useState(null);
  const [erro, setErro] = useState(false);

  useEffect(
    () =>
      onValue(
        ref(db, "googleUsers"),
        (snapshot) => {
          setCount(snapshot.size);
          setErro(false);
        },
        (error) => {
          console.error("Erro ao carregar contador de usuários Google:", error);
          setErro(true);
        },
      ),
    [],
  );

  if (erro) return null;

  const label =
    count === null
      ? "Contando jogadores..."
      : `${new Intl.NumberFormat("pt-BR").format(count)} ${
          count === 1 ? "jogador cadastrado" : "jogadores cadastrados"
        }`;

  return (
    <div className="google-users-counter" aria-live="polite" aria-label={label}>
      <span className="google-users-counter-dot" aria-hidden="true" />
      <span>{label}</span>
      <span className="google-users-counter-detail">com Google</span>
    </div>
  );
}
